import { useState } from "react";
import BaseClient from "../helper/Baseclient";
import { APIEndpoints } from "../constants/APIEndpoints";

const useReservation = () => {
  const [reservationLoading, setReservationLoading] = useState(false);
  const [recentEnquiries, setRecentEnquiries] = useState(null);
  const [todayEnquiries, setTodayEnquiries] = useState(null);
  const [upcomingEnquiries, setUpcomingEnquiries] = useState(null);
  const [enquiriesHistory, setEnquiriesHistory] = useState(null);
  const [enquiryActionLoading, setEnquiriyActionLoading] = useState(false);
  const [tokenError, setTokenError] = useState(null);
  const [upcomingwithTodays, setUpcomingwithTodays] = useState(null);
  const [tableLists, setTableLists] = useState(null);
  const [reservFoodpageTiming, setReservFoodpageTiming] = useState([]);
  const [closureList, setClosureList] = useState(null);
  const [closuresHistory, setClosureHistory] = useState(null);

  const fetchNewReservations = async (token) => {
    try {
      let adminToken = token;
      if (!token) {
        const token = window.localStorage.getItem("shopCustomToken");
        adminToken = token;
      }
      const headers = {
        "x-shopToken": adminToken,
      };
      setReservationLoading(true);

      await BaseClient.get(
        APIEndpoints.newReservationList,
        {},
        {
          onSuccess: (res) => {
            let resp = res?.data;
            if (resp) {
              setRecentEnquiries(resp);
            }
          },
          onFailed: (err) => {
            // const status = err.code;
            // if (status && status == 401) {
            //   setTokenError({ Status: "Token expired", error: true });
            // }
            console.log("New reservation error", err);
          },
          headers: headers,
        }
      );
    } finally {
      setReservationLoading(false);
    }
  };

  const todaysReservationList = async (token) => {
    try {
      let adminToken = token;
      if (!token) {
        const token = window.localStorage.getItem("shopCustomToken");
        adminToken = token;
      }
      const headers = {
        "x-shopToken": adminToken,
      };

      setReservationLoading(true);
      await BaseClient.get(
        APIEndpoints.currentReservationList,
        {},
        {
          onSuccess: (res) => {
            let resp = res?.data;

            if (resp && resp?.upcomingEnquiries) {
              setTodayEnquiries(resp?.upcomingEnquiries);
            }
          },
          onFailed: (err) => {
            console.log("todays Reservation error=>", err);
          },
          headers: headers,
        }
      );
    } finally {
      setReservationLoading(false);
    }
  };

  const upcomingwithtodaysReservationList = async (token) => {
    try {
      const token = window.localStorage.getItem("shopCustomToken");
      if (!token || token.length === 0) {
        console.error("SHOP TOKEN MISSING!");
        return;
      }
      const headers = {
        "x-shopToken": token,
      };

      setReservationLoading(true);
      await BaseClient.get(
        APIEndpoints.upcomingWithTodays,
        {},
        {
          onSuccess: (res) => {
            let resp = res?.data;

            if (resp && resp?.enquiriesList) {
              setUpcomingwithTodays(resp?.enquiriesList);
            }
          },
          onFailed: (err) => {
            console.error("todays Reservation error=>", err);
          },
          headers: headers,
        }
      );
    } finally {
      setReservationLoading(false);
    }
  };

  const fetchReservationHistory = async (token) => {
    try {
      let adminToken = token;
      if (!token) {
        const token = window.localStorage.getItem("shopCustomToken");
        adminToken = token;
      }
      const headers = {
        "x-shopToken": adminToken,
      };
      setReservationLoading(true);

      await BaseClient.get(
        APIEndpoints.reservationHistoryList,
        {},
        {
          onSuccess: (res) => {
            let resp = res?.data;

            if (resp && resp?.historyList) {
              setEnquiriesHistory(resp?.historyList);
            }
          },
          onFailed: (err) => {
            console.log("todays Reservation error=>", err);
          },
          headers: headers,
        }
      );
    } finally {
      setReservationLoading(false);
    }
  };

  const fetchFutureReservations = async (token) => {
    try {
      let adminToken = token;
      if (!token) {
        const token = window.localStorage.getItem("shopCustomToken");
        adminToken = token;
      }
      const headers = {
        "x-shopToken": adminToken,
      };
      setReservationLoading(true);

      await BaseClient.get(APIEndpoints.upcomingReservationList, null, {
        onSuccess: (res) => {
          let resp = res?.data;
          if (resp) {
            setUpcomingEnquiries(resp?.upcomingEnquiries);
          }
        },
        onFailed: (err) => {
          console.log("todays Reservation error=>", err);
        },
        headers: headers,
      });
    } finally {
      setReservationLoading(false);
    }
  };

  const addNewReservartion = async (
    payload,
    { onSuccess, onFailed, headers }
  ) => {
    try {
      setReservationLoading(true);

      await BaseClient.post(APIEndpoints.createNewReservation, payload, {
        onSuccess: onSuccess,
        onFailed: onFailed,
        headers: headers,
      });
    } finally {
      setReservationLoading(false);
    }
  };

  const fetchReservationById = async (
    payload,
    { onSuccess, onFailed, headers }
  ) => {
    try {
      setReservationLoading(true);

      await BaseClient.post(APIEndpoints.getReservationDetailsbyId, payload, {
        onSuccess: onSuccess,
        onFailed: onFailed,
        headers: headers,
      });
    } finally {
      setReservationLoading(false);
    }
  };

  const updateEnquiry = async (
    id,
    payload,
    { onSuccess, onFailed, headers }
  ) => {
    try {
      setEnquiriyActionLoading(true);

      await BaseClient.put(
        APIEndpoints.updateReservationDetails + `/${id}`,
        payload,
        {
          onSuccess: onSuccess,
          onFailed: onFailed,
          headers: headers,
        }
      );
    } finally {
      setEnquiriyActionLoading(false);
    }
  };

  const fetchAllTables = async () => {
    try {
      const token = window.localStorage.getItem("shopCustomToken");
      if (!token || token.length === 0) {
        console.error("SHOP TOKEN MISSING!");
        return;
      }
      const headers = {
        "x-shopToken": token,
      };

      setReservationLoading(true);
      await BaseClient.get(
        APIEndpoints.getActiveTableLists,
        {},
        {
          onSuccess: (res) => {
            let resp = res?.data;
            if (resp && resp?.activeTablesList) {
              setTableLists(resp?.activeTablesList);
            }
          },
          onFailed: (err) => {
            console.log("todays Reservation error=>", err);
          },
          headers: headers,
        }
      );
    } finally {
      setReservationLoading(false);
    }
  };

  const fetchAvailableTables = async (payload, { onSuccess, onFailed }) => {
    try {
      const token = window.localStorage.getItem("shopCustomToken");
      if (!token || token.length === 0) {
        console.error("SHOP TOKEN MISSING!");
        return;
      }
      const headers = {
        "x-shopToken": token,
      };

      setReservationLoading(true);

      await BaseClient.post(APIEndpoints.getAvailableTables, payload, {
        onSuccess: onSuccess,
        onFailed: onFailed,
        headers: headers,
      });
    } finally {
      setReservationLoading(false);
    }
  };

  const deleteReservation = async (id, { onSuccess, onFailed }) => {
    try {
      if (!id) {
        console.error("Id is required for deleting reservation!");
        return;
      }
      const token = window.localStorage.getItem("shopCustomToken");
      if (!token || token.length === 0) {
        console.error("SHOP TOKEN MISSING!");
        return;
      }
      const headers = {
        "x-shopToken": token,
      };

      setReservationLoading(true);

      await BaseClient.delete(APIEndpoints.deleteSingleReservation + `/${id}`, {
        onSuccess: onSuccess,
        onFailed: onFailed,
        headers: headers,
      });
    } finally {
      setReservationLoading(false);
    }
  };

  const getReservationTiming = async (shopId) => {
    try {
      setReservationLoading(true);
      const reservationKey =
        process.env.REACT_APP_FOODPAGE_RESERVATION_SECRET_KEY;

      if (!shopId || shopId.length == 0) {
        console.error("ShopId is invalid!");
        return;
      }

      const headers = {
        "x-secretkey": reservationKey,
      };

      await BaseClient.get(
        APIEndpoints.reservationTiming + `/${shopId}`,
        {},
        {
          onSuccess: (res) => {
            const resp = res?.data;

            if (resp?.timingList) {
              setReservFoodpageTiming(resp?.timingList);
            }
          },
          onFailed: (err) => {
            console.error("Error on fetching foodpage reservation timing");
          },
          headers,
        }
      );
    } finally {
      setReservationLoading(false);
    }
  };

  // Closures Module

  const getActiveColure = async () => {
    try {
      setReservationLoading(true);

      const token = window.localStorage.getItem("shopCustomToken");
      if (!token || token.length === 0) {
        console.error("SHOP TOKEN MISSING!");
        return;
      }
      const headers = {
        "x-shopToken": token,
      };

      await BaseClient.get(
        APIEndpoints.getClosures,
        {},
        {
          onSuccess: (res) => {
            setClosureList(res?.data?.activeClosureList ?? null);
          },
          onFailed: (err) => {
            console.error("Error on fetching Closure List", err);
          },
          headers,
        }
      );
    } finally {
      setReservationLoading(false);
    }
  };

  const closuresAllHistory = async () => {
    try {
      setReservationLoading(true);

      const token = window.localStorage.getItem("shopCustomToken");
      if (!token || token.length === 0) {
        console.error("SHOP TOKEN MISSING!");
        return;
      }
      const headers = {
        "x-shopToken": token,
      };

      await BaseClient.get(
        APIEndpoints.closuresHistory,
        {},
        {
          onSuccess: (res) => {
            setClosureHistory(res?.data?.closureHistoryList ?? null);
          },
          onFailed: (err) => {
            console.error("Error on fetching Closure List", err);
          },
          headers,
        }
      );
    } finally {
      setReservationLoading(false);
    }
  };

  const createNewClosure = async (payload, { onSuccess, onFailed }) => {
    try {
      setReservationLoading(true);

      const token = window.localStorage.getItem("shopCustomToken");
      if (!token || token.length === 0) {
        console.error("SHOP TOKEN MISSING!");
        return;
      }
      const headers = {
        "x-shopToken": token,
      };

      await BaseClient.post(APIEndpoints.newClosure, payload, {
        onSuccess: onSuccess,
        onFailed: onFailed,
        headers,
      });
    } finally {
      setReservationLoading(false);
    }
  };

  const removeClosure = async (id, { onSuccess, onFailed }) => {
    try {
      setReservationLoading(true);

      const token = window.localStorage.getItem("shopCustomToken");
      if (!token || token.length === 0) {
        console.error("SHOP TOKEN MISSING!");
        return;
      }
      const headers = {
        "x-shopToken": token,
      };

      await BaseClient.delete(APIEndpoints.deleteClosure + `/${id}`, {
        onSuccess: onSuccess,
        onFailed: onFailed,
        headers,
      });
    } finally {
      setReservationLoading(false);
    }
  };

  const alterReservationTiming = async (payload, { onSuccess, onFailed }) => {
    try {
      setReservationLoading(true);
      const token = window.localStorage.getItem("shopCustomToken");
      if (!token || token.length === 0) {
        console.error("SHOP TOKEN MISSING!");
        return;
      }
      const headers = {
        "x-shopToken": token,
      };
      await BaseClient.post(APIEndpoints.saveReservationTiming, payload, {
        onSuccess: onSuccess,
        onFailed: onFailed,
        headers: headers,
      });
    } finally {
      setReservationLoading(false);
    }
  };

  return {
    reservationLoading,
    fetchNewReservations,
    todaysReservationList,
    fetchReservationHistory,
    fetchFutureReservations,
    addNewReservartion,
    recentEnquiries,
    todayEnquiries,
    upcomingEnquiries,
    enquiriesHistory,
    fetchReservationById,
    updateEnquiry,
    enquiryActionLoading,
    tokenError,
    setTokenError,
    upcomingwithtodaysReservationList,
    upcomingwithTodays,
    fetchAllTables,
    tableLists,
    fetchAvailableTables,
    deleteReservation,
    getReservationTiming,
    reservFoodpageTiming,
    getActiveColure,
    closuresAllHistory,
    createNewClosure,
    removeClosure,
    closureList,
    closuresHistory,
    alterReservationTiming,
  };
};

export default useReservation;
